/**
 * About page bundle — creative but restrained: no pinning/scroll-jacking,
 * just smooth staggered reveals and a scrubbing horizontal timeline.
 * Enqueued only on the About Us page template (inc/enqueue.php).
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from './utils/motion.js';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('page-template-about')) return;
  if (prefersReducedMotion()) {
    gsap.set('.timeline__item, .team-card', { opacity: 1, y: 0 });
    return;
  }

  // Headline split-line rise, same language as the homepage hero but once, no pinning
  gsap.from('.about-hero .h1', {
    y: 40,
    opacity: 0,
    duration: 0.9,
    ease: 'power3.out',
  });
  gsap.from('.about-hero p', {
    y: 20,
    opacity: 0,
    duration: 0.8,
    delay: 0.15,
    ease: 'power3.out',
  });

  // Timeline items fade up as the horizontal strip is scrolled into view
  gsap.utils.toArray('.timeline__item').forEach((item, i) => {
    gsap.to(item, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      delay: i * 0.05,
      ease: 'power2.out',
      scrollTrigger: { trigger: item, start: 'left 90%', horizontal: false, once: true },
    });
  });

  // Team portraits: gentle stagger fade, subtle hover tilt
  gsap.utils.toArray('.team-card').forEach((card) => {
    gsap.from(card, {
      opacity: 0,
      y: 30,
      duration: 0.7,
      ease: 'power3.out',
      scrollTrigger: { trigger: card, start: 'top 88%', once: true },
    });
    const img = card.querySelector('img');
    card.addEventListener('mousemove', (e) => {
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      gsap.to(img, { rotateY: px * 8, rotateX: -py * 8, duration: 0.4, ease: 'power2.out' });
    });
    card.addEventListener('mouseleave', () => gsap.to(img, { rotateY: 0, rotateX: 0, duration: 0.5 }));
  });
});
